/*
 * Copyright 2023 Amazon.com, Inc. or its affiliates. All Rights Reserved.
 */

export const areListsEqual = (l1: any[], l2: any[]): boolean => {
    return l1.length === l2.length && l1.every(item => l2.includes(item));
};
